<template>
  <b-form-group
    label="Alt Başlık"
    label-for="subtitle"
  >
    <b-form-input
      id="subtitle"
      v-model="itemData.subtitle"
      placeholder="Alt Başlık"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'SubTitleText',
  components: { BFormInput, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['carousel/dataItem']
    },
  },
}
</script>
